<template>
  <v-container fluid class="pa-0 ma-0 boost-post">
    <v-row no-gutters class="h-100">
      <v-col cols="12">
        <GlobalNav></GlobalNav>
      </v-col>
      <v-col cols="12" class="d-flex h-100">
        <SideBar />
        <v-container class="boost-post-contain">
          <v-row no-gutters>
            <v-col cols="12">
              <BreadCrumb :linksData="linksData" class="mb-5" />
            </v-col>
            <v-col cols="6" md="6" sm="6" class="boost-header-title mb-2">
              <div class="header-title d-flex align-center ga-1">
                <button
                  v-html="svgIcon"
                  class="d-flex"
                  @click="backPublishPost"
                ></button>
                <p>{{ $t("boost_post") }}</p>
              </div>
            </v-col>
            <v-col cols="3" md="3" sm="6"></v-col>
            <v-col cols="3" md="3" sm="6" class="d-flex justify-end">
              <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ props: activatorProps }">
                  <v-btn
                    v-bind="activatorProps"
                    color="surface-variant"
                    text="Open Dialog"
                    variant="flat"
                    class="d-none"
                  ></v-btn>
                </template>

                <template v-slot:default="{ isActive }">
                  <v-card class="pa-4">
                    <v-card-title
                      class="d-flex justify-space-between align-center"
                    >
                      <div class="d-flex gap-2 align-center">
                        <v-icon class="mr-2" color="#1877F2"
                          >mdi-facebook</v-icon
                        >
                        <h2 class="text-h6">Select Ad Account </h2>
                      </div>
                    </v-card-title>
                    <!-- Facebook Section -->

                    <div class="pages-box">
                      <v-radio-group v-model="selectedFacebookPage" column>
                        <v-radio
                          v-for="page in facebookPages"
                          :key="page.id"
                          :label="page.organization_name"
                          :value="page.id"
                          class="mb-2"
                        >
                          <template #label>
                            <div class="d-flex flex-column">
                              <strong>{{
                                page.organization_name || page.account_name
                              }}</strong>
                              <small class="text-muted">{{ page.id }}</small>
                            </div>
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </div>

                    <!-- Actions -->
                    <div class="d-flex justify-end ga-2 mt-4">
                      <v-btn
                        variant="outlined"
                        color="primary"
                        @click="clearSelection"
                        >Clear</v-btn
                      >
                      <v-btn color="primary" @click="dialog = false"
                        >Done</v-btn
                      >
                    </div>
                  </v-card>
                </template>
              </v-dialog>
            </v-col>
          </v-row>
          <v-row no-gutters class="boost-post-data">
            <v-col cols="8" class="">
              <TapsPlatform />
            </v-col>
            <v-col cols="4" class="pa-2">
              <!-- <ReviewPosts /> -->
              <NewReview />
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SideBar from "@/components/layout/SideBar.vue";
import GlobalNav from "@/components/layout/GlobalNav.vue";
import BreadCrumb from "@/components/layout/BreadCrumb.vue";
import TapsPlatform from "@/components/boost-post/TapsPlatform.vue";
import ReviewPosts from "@/components/publish_post_components/ReviewPosts.vue";
import NewReview from "@/components/publish_post_components/NewReview.vue";
import { boostPost } from "@/store/publishPost/boostPost";
import apiClient from "@/core/buildRequest";
export default {
  components: {
    GlobalNav,
    SideBar,
    BreadCrumb,
    TapsPlatform,
    ReviewPosts,
    NewReview,
  },
  data() {
    return {
      selectedFacebookPage: null,
      facebookPages: [],
      linksData: [
        { name: "Home", link: "/home-page" },
        { name: "Publish Post", link: "" },
      ],
      dialog: true,
      svgIcon: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="rgba(31, 102, 106, 1)"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>`,
      store: boostPost(),
    };
  },
  methods: {
    async getAdAccount() {
      try {
        const response = await apiClient.get("/ad-performance/get/all/accounts");
        this.facebookPages = response.data.data;
      } catch (error) {
        console.error(
          "❌ Failed to fetch accounts",
          error.response?.data?.msg || error.message
        );
      }
    },
    backPublishPost() {
      this.$router.push({ name: "PublishPost" });
    },
    clearSelection() {
      this.selectedFacebookPage = null;
    },
  },
  mounted() {
    this.getAdAccount();
  },
};
</script>
<style scoped>
.v-expansion-panel-title {
  font-weight: 500;
}
.pages-box {
  background-color: #f7f7f7;
  border-radius: 0.6rem;
  max-height: 32rem;
  overflow-y: scroll;
  padding: 1.3rem;
}
</style>
